import { render, staticRenderFns } from "./PerformanceTargetStatusChip.vue?vue&type=template&id=1674fa92"
import script from "./PerformanceTargetStatusChip.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports